import React, { useContext, useEffect, useState } from "react";
import LoadingElement from "../../components/elements/Loading.Element";
import { DB_REF } from "../../constants/DB";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { Player } from "../../interfaces/Player.Interface";
import playerImg from "../../img/player_default.png";
import "./PlayerList.Styles.scss";

export default function PlayerListComponent() {
  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState<Player[]>([]);
  const firebase = useContext(firebaseContext);
  useEffect(() => {
    const getPlayers = async () => {
      const col = await firebase.firestore().collection(DB_REF.players).get();
      if (!col.empty) {
        setPlayers([]);
        col.forEach((doc) => {
          setPlayers((old) => [...old, (doc as any).data()]);
        });
      }
      setLoading(false);
    };
    getPlayers();
  }, [firebase]);

  if (loading) {
    return <LoadingElement />;
  }

  const renderPlayerData = () => {
    return players.map((ele, index) => {
      return (
        <div
          className="player-list-element"
          key={index}
          style={{ padding: 10, display: "flex", alignItems: "center" }}
        >
          <div>
            <img height={"70px"} src={ele.imageUrl || playerImg} alt="" />
          </div>
          <div style={{ paddingLeft: 20, flex: 12 }}>
            {ele.firstName + " " + ele.lastName}
          </div>
          <div
            style={{
              paddingRight: 20,
              fontWeight: "bolder",
              fontSize: "25px",
              flex: 5,
              textAlign: "end",
            }}
          >
            {ele.jerseyNumber}
          </div>
          <div style={{ flex: 3 }}>{ele.position.toUpperCase()}</div>
        </div>
      );
    });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          padding: 25,
        }}
      >
        Players
      </div>
      <div>{renderPlayerData()}</div>
    </div>
  );
}
